import {css} from '@emotion/react'
import {useMapContext} from '@/components/MindMap/index.mjs'
import NodeExtraText from './NodeExtraText.jsx'

const cssVersionText = css({
})

const cssVersionTextOutdated = css({
    color: 'red !important',
})

export default function NodeVersion({node, ...props}) {
    const map = useMapContext()
    const _n = map.nodeProxy(node)

    if (! _n.showVersion()) {
        return null
    }

    const version = _n.getVersion()

    if (! version) {
        return null
    }

    const fromVer = (() => {
        if (! /^_(CHG|DES)_MAP/.test(map.data.mapTypeCode)) {
            return ''
        }

        const {basRev, deliverRev, deliverVer, sVer} = node.data

        if (basRev) {
            return `${sVer}.${basRev}`
        }

        if (deliverRev && deliverVer) {
            return `${deliverVer}.${deliverRev}`
        }

        return ''
    })()

    const text = fromVer ?
        `【${version}】←【${fromVer}】`
        :
        `【${version}】`

    const csss = [cssVersionText]

    if (_n.isOutdated()) {
        csss.push(cssVersionTextOutdated)
    }

    return (
        <NodeExtraText
            css={csss}
            node={node}
            text={text}
            {...props}
        />
    )
}
